import { useLiveQuery } from 'dexie-react-hooks';
import { type AppDatabase, db } from './db';

type Querier<T> = (db: AppDatabase) => Promise<T>;

const LOADING = Symbol('loading');
type Loading = typeof LOADING;

export function useAppLiveQuery<T>(
    querier: Querier<T>,
    deps?: unknown[],
): T | undefined {
    return useLiveQuery(() => querier(db), deps);
}

export function useAppLiveQueryState<T>(
    querier: Querier<T>,
    deps?: unknown[],
): { value: T | undefined; isLoading: boolean } {
    const result = useLiveQuery<T, Loading>(
        () => querier(db),
        deps ?? [],
        LOADING,
    );

    const isLoading = result === LOADING;

    return {
        value: isLoading ? undefined : result,
        isLoading,
    };
}
